import { Card, CardContent, CardMedia, Stack, Typography, useTheme } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';

import { Scrollbar } from '../scrollbar';
import { Iconify } from '../iconify';
import { IHoliday } from '@app/modules/holidays';
import { Strings } from '@app/constants';

interface Props {
  holidays: any;
  title: string;
}
const UpcomingHolidaysCard = ({ holidays, title }: Props) => {
  const theme = useTheme();
  const isHoliday = (date: dayjs.Dayjs) => {
    return holidays?.some((holiday: IHoliday) => dayjs(holiday.date).isSame(date, 'day'));
  };

  return (
    <Stack p={1}>
      <Typography variant="h6" pt={1} pl={3}>
        {title}
      </Typography>

      <DateCalendar
        shouldDisableDate={(date: Dayjs) => !isHoliday(date)}
        readOnly
        sx={{
          height: 284,
          mt: 0.5,
          mb: 1,
          '& .MuiPickersDay-root': {
            pointerEvents: 'none',
          },
          '& .MuiIconButton-root': {
            display: 'none',
          },
        }}
      />
      <Scrollbar sx={{ height: 100 }}>
        {holidays?.length === 0 ? (
          <Stack
            p={1}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            mt={1}
          >
            <Typography sx={{ fontSize: '14px', color: theme.palette.grey[600] }}>
              {Strings.dashboard.noHoliday}
            </Typography>
          </Stack>
        ) : (
          holidays?.map((item: IHoliday, index: number) => (
            <Card key={index} sx={{ borderRadius: '10px', ml: 5, mt: 1, mr: 4.5, mb: 1 }}>
              <Stack direction="row" spacing={1} justifyContent="space-evenly" alignItems="center">
                <Stack
                  gap={1}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <Stack>
                    <Iconify
                      icon="ion:ellipse-sharp"
                      width={12}
                      sx={{ color: (theme) => theme.palette.primary.main }}
                    />
                  </Stack>
                  <Stack alignItems="center">
                    <Typography
                      variant="subtitle2"
                      color="grey.700"
                      textTransform="uppercase"
                      whiteSpace={'nowrap'}
                    >
                      {dayjs(item.date).format('DD MMM')}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack mr={2}>
                  <Card sx={{ width: 200, height: 40, borderRadius: '8px' }}>
                    <CardMedia
                      component="img"
                      height="140"
                      image={item.image}
                      alt="description_of_image"
                    />
                    <CardContent
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: theme.palette.common.white,
                        background: 'rgba(0, 0, 0, 0.5)',
                      }}
                    >
                      <Typography variant="body2" component="div">
                        {item.name}
                      </Typography>
                    </CardContent>
                  </Card>
                </Stack>
              </Stack>
            </Card>
          ))
        )}
      </Scrollbar>
    </Stack>
  );
};

export { UpcomingHolidaysCard };
